import { createSlice } from "@reduxjs/toolkit";
import { CampaignState, ICampaign } from ".";


const initialCampaign: ICampaign = {
	count: 0,
	campaigns: [],
	campaign: {},
	loading: true,
	current_filters: {},
	filters: {},
	revenue: null,
	revenueLoading: false,
	isApprover: false,
};

const initialState: CampaignState = {
	tab: 0,
	user: initialCampaign,
	partner: initialCampaign
};

export const campaignSlice = createSlice({
	name: "campaign",
	initialState,
	reducers: {
		setLoading: (state, action: { payload: { type: 'user' | 'partner', loading: boolean } }) => {
			const { type, loading } = action.payload;
			state[type].loading = loading;
		},
		setTab: (state, action) => {
			state.tab = action.payload;
		},
		addCampaign: (state, action: { payload: { type: 'user' | 'partner', campaign: any } }) => {
			const {type , campaign} = action.payload;
			state[type].campaigns.unshift(campaign);
			state[type].count += 1;
		},
		updateCampaign: (state, action: { payload: { id: string; campaign: any; type: 'user' | 'partner' } }) => {
			const { id, campaign, type } = action.payload;
			state[type].campaigns = state[type].campaigns.map((c: any) =>
				c._id === id ? campaign : c
			);
		},
		deleteCampaign: (state, action: { payload: { id: string; type: 'user' | 'partner' } }) => {
			const { id, type } = action.payload;
			state[type].campaigns = state[type].campaigns.filter((c: any) => c._id !== id);
			state[type].count -= 1;
		},
		setCampaigns: (state, action: { payload: { type: 'user' | 'partner', campaigns: any[] } }) => {
			const { campaigns, type } = action.payload;
			state[type].campaigns = campaigns;
			state[type].count = campaigns.length;
		},
		setCampaign: (state, action: { payload: { type: 'user' | 'partner', campaign: any } }) => {
			const { campaign, type } = action.payload;
			state[type].campaign = campaign;
		},
		setIsApprover: (state, action: { payload: { type: 'user' | 'partner', isApprover: boolean } }) => {
			const { type, isApprover } = action.payload;
			state[type].isApprover = !!isApprover;
		},
		setFilters: (state, action: { payload: { type: 'user' | 'partner', filters: any } }) => {
			const { type, filters } = action.payload;
			state[type].filters = filters;
			state[type].current_filters = filters;
		},
		resetFilters: (state, action: { payload: { type: 'user' | 'partner' } }) => {
			const { type } = action.payload;
			state[type].filters = {};
			state[type].current_filters = {};
			state[type].revenue = null;
		},
		setRevenue: (state, action: { payload: { type: 'user' | 'partner', revenue: any } }) => {
			const { type, revenue } = action.payload;
			state[type].revenue = revenue;
		},
		setRevenueLoading: (state, action: { payload: { type: 'user' | 'partner', loading: boolean } }) => {
			const { type, loading } = action.payload;
			state[type].revenueLoading = loading;
		},
	},
});
const campaignReducer = campaignSlice.reducer;

export const campaignActions = campaignSlice.actions;
export default campaignReducer;
